// import axios from "axios"
// //doudou  钱包相关
// if (process.env.NODE_ENV === 'production') {
//     // 正式
//     //axios.defaults.baseURL = 'https://gateway.jftpay.hkrt.cn/app-api/api'; //海科正式
//     axios.defaults.baseURL = 'https://hkmc-gateway.verapay.cn/app-api/api'; //海科测试
// } else {
//     axios.defaults.baseURL = 'https://hkmc-gateway.verapay.cn/app-api/api'; //海科测试
// }
// // 公共接口
// // 测试
// export const baseUrl = (url, params) => axios.post(url, params)

import axios from "axios"

// if (process.env.NODE_ENV === 'production') {
//     // axios.defaults.baseURL = 'http://101.52.127.100/center-gateway/center-app/app-api/api'; // 海科正式-新-IP
//     // axios.defaults.baseURL = 'https://gateway.jftpay.hkrt.cn/app-api/api'; //海科正式-新-处理后

//     axios.defaults.baseURL = 'http://101.52.141.93:12080/center-app/app-api/api'; // 海科测试-外网
// } else {
//     // axios.defaults.baseURL = 'http://172.16.27.8:12080/center-app/app-api/api'; // 海科测试-内网
//     axios.defaults.baseURL = 'http://101.52.141.93:12080/center-app/app-api/api'; // 海科测试-外网
// }

axios.defaults.baseURL = process.env.VUE_APP_BASE_API

// 公共接口
// 测试
export const baseUrl = (url, params) => axios.post(url, params)
